import {Component, OnInit} from "@angular/core";
import {UmRoleObjectBaseComponent} from "../um-role-object-base.component";

@Component({
    selector: "um-role-object-full",
    templateUrl: "./um-role-object-full.component.html",
    standalone: false
})

export class UmRoleObjectFullComponent extends UmRoleObjectBaseComponent implements OnInit {


    ngOnInit() {
        super.ngOnInit();
    }
}
